import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Divider,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SegregationLocation_Detail } from "../../../Server/ApiV2";
import { CmpStatusIconV3, CmpStatusIconV4 } from "../../../Component/Common/ToolBox/ToolBox";

const LocationWiseModal = ({
  open,
  handleClose,
  data,
  selectedItem,
  xOnClick = () => {},
  vMediaQuery,
}) => {
  const [viewData, setViewData] = useState([]);

  const locationWiseData = async () => {
    const obj = {
      VocTyp: selectedItem?.A_VocTyp,
      VocNo: selectedItem?.A_VocNo,
    };
    const result = await SegregationLocation_Detail(obj);
    console.log(result);

    if (result.status === 200) {
      
  
      const groupedData = Object.values(
        result?.data?.ResultSet?.reduce((acc, { Location, LocName, TotalBaseQty, TotalPickedQty, BalanceQty ,NumberID}) => {
          const key = `${Location}-${LocName}`;
          
          if (!acc[key]) {
            acc[key] = { Location, LocName, NumberID,TotalBaseQty: 0, TotalPickedQty: 0, BalanceQty: 0 };
          }
      
          acc[key].TotalBaseQty += TotalBaseQty;
          acc[key].TotalPickedQty += TotalPickedQty;
          acc[key].BalanceQty += BalanceQty;
      
          return acc;
        }, {})
      );
          
      const updatedData = groupedData.map((item) => {
        let indicator;
        if (item.BalanceQty === 0) {
          indicator = 3; // Green
        } else if (item.TotalPickedQty > 0) {
          indicator = 1; // Yellow
        } else {
          indicator = 2; // Red
        }
        return {
          ...item, // Spread existing properties
          Indicator: indicator, // Add the new key
        };
      })?.sort((a, b) => a.Indicator - b.Indicator);
      console.log("updatedData",updatedData);
      
      setViewData(updatedData);
    }
  };

  console.log(viewData);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        locationWiseData();
      }, 1000);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={()=>{
        setViewData([]);
        handleClose()
      }
      }
      aria-labelledby="view-segregation-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: vMediaQuery ? "95%" : "75%",
          bgcolor: "white",
          boxShadow: 24,
          borderRadius: 2,
          paddingY: vMediaQuery ? 1 : 2,
          paddingX: vMediaQuery ? 1 : 3,
          display: "flex",
          flexDirection: "column",
          //alignItems: "center", // Center card inside modal
          // justifyContent: "center",
        }}
      >
        {/* Header */}
        <Box display="flex" justifyContent="space-between" mb={0.5}>
          <Typography variant="h6" id="view-segregation-modal">
            Location Wise
            <Typography
              variant="body2"
              color="primary"
              sx={{ cursor: "pointer", fontWeight: 600 }}
            >
              {data?.A_VocNo}, {data?.SegregationMethod}
            </Typography>
          </Typography>

          <IconButton onClick={()=>{
        setViewData([]);
        handleClose()
      }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />

        {/* Card Container */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: vMediaQuery ? "80vh" : "70vh",
            overflowY: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={vMediaQuery ? 1 : 2}
            mb={1}
            paddingY={1}
            paddingX={vMediaQuery ? 0.5 : 2}
          >
            <Grid container spacing={vMediaQuery ? 1 : 2}>
              {viewData?.map((row, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    sx={{
                      width: "100%",
                      borderRadius: 3,
                      boxShadow: 2,
                      border: "1px solid #FAF9F6",
                      "& .MuiCardContent-root": {
                        padding: "5px !important",
                      },
                      //   textAlign: "center", // Align text inside the card
                    }}
                  >
                    <CardContent
                      onClick={() => {
                        xOnClick(row);
                      }}
                    >
                      {/* <Typography
                        variant={vMediaQuery ? "subtitle2" : "subtitle1"}
                        fontWeight="bold"
                        fontSize={vMediaQuery ? "14px" : "16px"}
                      >
                        {row?.LocName}
                      </Typography> */}
                      <Box sx={{ backgroundColor: "#FAF9F6", p: 1.5 }}>
                        {/* Name and Position */}
                        <Grid container>
                          <Grid item xs={10}>
                            {/* <Typography variant="h6" fontWeight="bold"> */}
                            <Typography variant="h6" fontWeight="bold">
                              {row.LocName}
                            </Typography>
                          </Grid>
                          <Grid item xs={2} textAlign={"right"}>
                            <CmpStatusIconV4 xStatus={row.Indicator}  NumberId={row?.NumberID || ""}/>
                          </Grid>
                        </Grid>
                      </Box>

                      {/* <Typography
                        variant="caption"
                        color="gray"
                        sx={{ display: "block" }}
                      >
                        {row?.ItemCode}
                      </Typography> */}

                      {/* Last 90 Days Stats */}
                      <Box
                        sx={{
                          backgroundColor: "#F4F4F4",
                          borderRadius: 2,
                          p: "10px",
                          mt: 0.5,
                        }}
                      >
                        {/* <Typography variant="subtitle2" fontWeight="bold">
                      Last 90 days
                    </Typography> */}
                        <Grid container spacing={1}>
                          <Grid item xs={4}>
                            <Typography variant="caption" color="gray">
                              Qty
                            </Typography>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {(row.TotalBaseQty).toFixed(0)}
                            </Typography>
                          </Grid>
                          <Grid item xs={5}>
                            <Typography variant="caption" color="gray">
                              Seg.Qty
                            </Typography>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {(row.TotalPickedQty).toFixed(0)}
                            </Typography>
                          </Grid>
                          <Grid item xs={3}>
                            <Typography variant="caption" color="gray">
                              Balance
                            </Typography>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {(row.BalanceQty).toFixed(0)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </div>
      </Box>
    </Modal>
  );
};

export default LocationWiseModal;
